// The title reducer for the analytics.
// @flow
import { ACTIONS } from '../actions';
import type { TitleState } from '../constants';

type Action = {
    title: TitleState,
    type: string
};

export const title = (
    state: TitleState = '',
    action: Action = { type: '', title: '' }
): TitleState => {
    switch (action.type) {
        case ACTIONS.INITIALIZE:
            if (action.title) {
                return action.title;
            }
            return state;
        default:
            return state;
    }
};
